<template>
  <div class="mask" :class="{ maskActive: isOpenCartDialog }" @click="closeMobileCartDialog" />
  <transition name="slide-up">
    <div v-if="isOpenCartDialog" id="dialog-market" class="dialog-bottom dialog-item">
      <div class="dialog-bottom-content">
        <div class="item-info">
          <div class="d-flex">
            <div class="col-8">
              <div class="item-attribute">
                <span
                  v-if="selectedSpec.IsOutOfStock !== undefined && !selectedSpec.IsOutOfStock"
                  class="item-preorder"
                >
                  [ {{ isPreOrder }} ]
                </span>
                <span class="item-temp"> [{{ productTemperature }}] </span>
              </div>
              <div class="item-name" :class="{ noEvent }">
                {{ itemDatas.Name }}
              </div>
              <div v-if="!noEvent" class="product-event">
                <div v-if="itemDatas.Limit !== 0" class="event-text">
                  此商品限購 {{ itemDatas.Limit }} 件
                </div>
                <div v-for="event in itemDatas.Events" :key="event.ID">
                  <a :href="'/campaign/' + event.ID" class="event-text">{{ event.Name }}</a>
                </div>
                <div v-for="giftEvent in itemDatas.GiftEvents" :key="giftEvent.ID">
                  <a :href="'/campaign/gift/' + giftEvent.ID" class="event-text">{{
                    giftEvent.Name
                  }}</a>
                </div>
              </div>
              <div class="item-price">
                <span
                  v-if="hasCheaperPrice"
                  class="origin-price"
                  :class="{
                    mark: hasCheaperPrice,
                  }"
                >
                  NT.{{ itemDatas.OriginPrice.toLocaleString('en-US') }}
                </span>
                <span
                  class="sell-price"
                  :class="{
                    mark: hasCheaperPrice,
                  }"
                >
                  NT.{{ mapSellPrice }}
                </span>
              </div>
              <ul class="product-color-wrap">
                <li
                  v-for="color in itemDatas.Colors"
                  :key="color.ID"
                  class="product-color"
                  :class="{ active: color.ID === selectedData.ID }"
                  @click="changeImg(color.ID)"
                >
                  <img class="m-0" :src="color.PintSizePictureUrl + '?w=16&h=16'" />
                </li>
              </ul>
            </div>
            <div class="col-4">
              <NewImage
                v-if="selectedData.Images.length !== 0"
                :url="selectedData.Images[0].Url"
                class="dialog-img"
                :size="'_w300_h400'"
                :name="itemDatas.Name"
              />
            </div>
          </div>
          <div class="select-container">
            <div class="col-6">
              <p class="mb-1">SIZE</p>
              <Select
                :options="selectedData.Specs"
                :selected="selectedSpec"
                @changeSpec="selectSpec"
              />
            </div>
            <div class="col-6">
              <p class="mb-1">Quantity</p>
              <div class="UiQuantity">
                <button class="btn UiQuantity__btn float-left" @click.prevent="reduceCount">
                  –
                </button>
                <span class="UiQuantity__text">{{ counter }}</span>
                <button
                  class="btn UiQuantity__btn float-right"
                  @click.prevent="
                    addCount({ maxCount: selectedSpec.Stock, limit: itemDatas.Limit })
                  "
                >
                  ＋
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-bottom-container">
          <button
            :class="btnStyleGenerate"
            class="btn dialog-bottom-btn"
            @click.prevent="clickToCart(addToCart)"
          >
            {{ btnDescriptionGenerate }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import NewImage from '@global/components/common/Image/NewImage.vue';
import Select from '@components/Select.vue';

import useShopContentStore from '@global/stores/useShopContentStore';
import useSpec from '@global/composable/useSpec';

const shopContentStore = useShopContentStore();
const { selectSpec, changeImg, addCount, reduceCount, closeMobileCartDialog, addToCart } =
  shopContentStore;
const {
  selectedData,
  itemDatas,
  selectedSpec,
  counter,
  isOpenCartDialog,
  btnStyleGenerate,
  btnDescriptionGenerate,
} = storeToRefs(shopContentStore);

const {
  IsPreOrderFactory,
  IsMapSellPriceFactory,
  IsHasCheaperPriceFactory,
  IsProductTemperatureFactory,
  IsNoEventFactory,

  clickToCart,
} = useSpec();

const isPreOrder = computed(() => IsPreOrderFactory(selectedSpec.value));
const mapSellPrice = computed(() => IsMapSellPriceFactory(itemDatas.value));
const hasCheaperPrice = computed(() => IsHasCheaperPriceFactory(itemDatas.value));
const productTemperature = computed(() => IsProductTemperatureFactory(itemDatas.value));
const noEvent = computed(() => IsNoEventFactory(itemDatas.value));
</script>
